import {
  OnInit,
  OnDestroy,
  inject,
  ChangeDetectorRef,
  Directive
} from '@angular/core';
import { InstantSearchService } from 'app/services/algolia/algolia-instant-search.service';

@Directive()
export abstract class BaseWidget<TState> implements OnInit, OnDestroy {
  protected algoliaService = inject(InstantSearchService);
  protected cd = inject(ChangeDetectorRef);

  state: TState | undefined = undefined;
  private widget: any;

  abstract createWidget(): any;

  ngOnInit() {
    this.widget = this.createWidget();
    this.algoliaService.addWidgets([this.widget]);
  }

  ngOnDestroy() {
    this.algoliaService.removeWidgets([this.widget]);
  }

  protected updateState(state: TState) {
    this.state = state;
    this.cd.detectChanges();
  }
}
